const Navbar = () => {
  return (
    <div className="flex justify-between text-white bg-gray-900">
      <div className="p-6 text-xl">
        Aman
      </div>
      <div>
        <ul className="flex gap-x-28 p-6 text-xl">
          <button>Home</button>
          <button onClick={() => window.scrollTo({ top: 800, behaviour: "smooth" })}>Skills</button>
          <button onClick={() => window.scrollTo({ top: 1400, behaviour: "smooth" })}>Contact Me</button>
        </ul>
      </div>
    </div>
  )
}
export default Navbar;
